import gql from 'graphql-tag';
import className from 'classnames/bind';
import { SectionEndFragment } from '@graphqlTypes';

import styles from './SectionEnd.module.scss';
const cx = className.bind(styles);

export default function SectionEnd({ sectionId }: SectionEndFragment) {
  return (
    <div className={cx(["section-end"])} data-section-id={sectionId} />
  )
}

SectionEnd.fragments = {
  entry: gql`
    fragment SectionEnd on FlexiblePageContentContentSectionEndLayout {
      sectionId
    }
  `,
};